import * as React from "react";

function SvgWrench(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.94 23.87"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M15.48 12.6L4.73 23.33a1.77 1.77 0 01-1.31.54 1.86 1.86 0 01-1.32-.54L.55 21.76a1.71 1.71 0 01-.56-1.31 1.8 1.8 0 01.55-1.32L11.29 8.42a7.3 7.3 0 001.7 2.54 7.28 7.28 0 002.49 1.64zM4.99 20.18a.92.92 0 00.28-.66.9.9 0 00-.28-.65.92.92 0 00-.66-.28.9.9 0 00-.65.28.86.86 0 00-.28.65.94.94 0 00.93.93.91.91 0 00.66-.27zM23.9 5.96a4.81 4.81 0 01-.06 1.57 6.59 6.59 0 01-5.31 5.43 6.27 6.27 0 01-4.87-1.09 6.24 6.24 0 01-2.67-4.23 6.23 6.23 0 011.08-4.86A6.28 6.28 0 0116.27.1a6.93 6.93 0 011.78-.07 5 5 0 011.66.39.49.49 0 01.3.36.46.46 0 01-.16.44l-3.77 3.16.56 3.2 3 1 1-.9 1.74-1.5a4.68 4.68 0 01.92-.68.43.43 0 01.37.08.54.54 0 01.23.38z" />
    </svg>
  );
}

const MemoSvgWrench = React.memo(SvgWrench);
export default MemoSvgWrench;
